var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7974 5.32998C22.6512 6.30321 22.6512 7.69678 21.7974 8.67001C20.2608 10.4217 17.1627 12.9231 12 12.9231C6.8373 12.9231 3.7392 10.4217 2.20257 8.67001C1.34883 7.69678 1.34883 6.30321 2.20257 5.32998C3.7392 3.57829 6.8373 1.07692 12 1.07692C17.1627 1.07692 20.2608 3.57829 21.7974 5.32998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 6.99999,
    r: 3.38462,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9546283277e1fbf084d86e8b47ac714b.svg";
export { ForwardRef as ReactComponent };